import PrepaidItemsPurchaseModal, {
  PREPAID_ITEMS_PURCHASE_MODAL,
} from './modal';

export { PREPAID_ITEMS_PURCHASE_MODAL };

export default PrepaidItemsPurchaseModal;
